import {Dialog, DialogContent, DialogTitle, Grid, TextField, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import * as React from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const ETollMerfDetails = (props: any) => {

    const {t} = useTranslation('finance', {keyPrefix: 'etoll'});
    const tollDetails = props.tollDetails;
    const open = props.open;

    return (

        <Dialog maxWidth={"md"} open={open}
                onClose={() => {
                    props.onClose();
                }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {tollDetails?.equipmentNumber + " - " + tollDetails?.registration}
                </Typography>
                <IconButton
                    aria-label="close" onClick={() => props.onClose()}
                    sx={{position: 'absolute', right: 8, top: 8,}}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container columnSpacing={3} rowSpacing={1}>

                    <Grid item md={12} xs={12}>
                        <TextField
                            fullWidth
                            id="country"
                            value={tollDetails?.reportMerf?.fileName}
                            label={t("tables.charge.fileMerf")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <TextField
                            fullWidth
                            id="city"
                            value={tollDetails?.errorCode ? tollDetails.errorCode.startsWith('charges.')
                                ? t(`${tollDetails.errorCode}`) : tollDetails.errorCode : ''}
                            label={t("tables.charge.errorCode")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <TextField
                            fullWidth
                            id="zipCode"
                            value={tollDetails?.errorDescription}
                            label={t("tables.charge.errorDescription")}
                            type="text"
                            InputLabelProps={{shrink: true}}
                            disabled={true}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>

    );
};

export default ETollMerfDetails;